import { datadogRum } from '@datadog/browser-rum';
import { DidomiSDK, IDidomiObject } from '@didomi/react';
import JsCookie from 'js-cookie';
import Script from 'next/script';

import { useState } from 'react';
import ZendeskWidget from './ZendeskWidget';
import { useCmsData } from './cms';

const MANDATORY_COOKIES = ['euconsent-v2', 'didomi_token', 'context-hash', 'user-context-hash'];
const MANDATORY_VENDORS = ['altered-xfUHAx2d', 'datadog-pmHc8yEk', 'zendesk-TZdrM2Ta'];

const removeNotMandatoryCookies = () => {
  const cookiesToRemove = document.cookie
    .split(';')
    .map((cookie) => cookie.split('=')[0].trim())
    .filter((cookieName) => !MANDATORY_COOKIES.includes(cookieName));

  cookiesToRemove.forEach((cookieName) => {
    JsCookie.remove(cookieName);
  });
};

const onConsentChanged = () => {
  const data = window.Didomi?.getCurrentUserStatus();

  const areAllVendorsAndPurposesDisabled = Object.entries(data?.vendors || {}).every(
    ([vendorId, vendor]) => MANDATORY_VENDORS.includes(vendorId) || !vendor.enabled,
  );

  if (areAllVendorsAndPurposesDisabled) {
    removeNotMandatoryCookies();
  }
};

const CookieConsent = () => {
  const [zendeskEnabled, setZendeskEnabled] = useState(false);
  const { generalSettings } = useCmsData();

  const onReady = (didomi: IDidomiObject) => {
    didomi
      .getObservableOnUserConsentStatusForVendor('c:datadog-pmHc8yEk')
      .filter((status: boolean) => status === true)
      .first()
      .subscribe((consentStatusForVendor: boolean) => {
        datadogRum.setTrackingConsent(consentStatusForVendor ? 'granted' : 'not-granted');
      });

    didomi
      .getObservableOnUserConsentStatusForVendor('c:zendesk-TZdrM2Ta')
      .filter((status: boolean) => status === true)
      .first()
      .subscribe((consentStatusForVendor: boolean) => {
        setZendeskEnabled(consentStatusForVendor);
      });
  };

  return (
    <>
      <DidomiSDK
        apiKey="885be1a5-a56c-4aee-b195-83788598461b"
        iabVersion={2}
        noticeId="XUejnXDb"
        onConsentChanged={onConsentChanged}
        onReady={onReady}
        gdprAppliesGlobally
      />
      {zendeskEnabled && <ZendeskWidget />}
      {generalSettings?.google_tag_manager && (
        <Script
          data-id={generalSettings?.google_tag_manager}
          id="gtm-pixel"
          src="/scripts/google-tag-manager.js"
          strategy="afterInteractive"
        />
      )}
    </>
  );
};

export default CookieConsent;
